module.exports = __webpack_public_path__ + "img/borussia-monchengladbach.0374208e.png";